// extracted by mini-css-extract-plugin
export default {"Layout":"Layout_Layout__dlw3Y","row":"Layout_row__QShAi","col":"Layout_col__3bTqV"};